import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { SettingsIcon, PlusIcon, CheckCircleIcon } from 'lucide-react';
const workflowRules = [{
  name: 'Bank Detail Change Approval',
  trigger: 'Supplier updates bank details',
  action: 'Route to Finance Queue (Maker-Checker)',
  status: 'Active'
}, {
  name: 'High Risk Supplier Onboarding',
  trigger: 'Risk Score > 70 during onboarding',
  action: 'Route to Compliance Queue',
  status: 'Active'
}, {
  name: 'Invoice Price Variance',
  trigger: 'Invoice price > PO price by 5%',
  action: 'Flag as Exception, Route to Buyer',
  status: 'Active'
}];
export const AdminConfigPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('workflows');
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-288">
      <PageHeader title="Admin & Configuration" description="Configure portal rules, templates, and permissions." data-id="element-289" />

      <Card noPadding data-id="element-290">
        <div className="px-6 pt-4 border-b border-border-light overflow-x-auto" data-id="element-291">
          <Tabs tabs={[{
          id: 'workflows',
          label: 'Workflow Rules'
        }, {
          id: 'documents',
          label: 'Document Requirements'
        }, {
          id: 'validation',
          label: 'Validation Rules'
        }, {
          id: 'notifications',
          label: 'Notifications'
        }, {
          id: 'integrations',
          label: 'Integrations'
        }, {
          id: 'roles',
          label: 'Roles'
        }, {
          id: 'audit',
          label: 'Audit Log'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-292" />
        </div>
        <div className="p-6" data-id="element-293">
          {activeTab === 'workflows' && <div className="space-y-4" data-id="element-294">
              <div className="flex justify-between items-center" data-id="element-295">
                <h3 className="text-lg font-semibold text-text-primary" data-id="element-296">
                  Active Workflow Rules
                </h3>
                <Button variant="primary" leftIcon={<PlusIcon className="w-4 h-4" data-id="element-298" />} data-id="element-297">
                  Create Rule
                </Button>
              </div>
              <DataTable data={workflowRules} columns={[{
            header: 'Rule Name',
            accessorKey: 'name',
            cell: row => <span className="font-medium" data-id="element-300">{row.name}</span>
          }, {
            header: 'Trigger Event',
            accessorKey: 'trigger'
          }, {
            header: 'Action',
            accessorKey: 'action'
          }, {
            header: 'Status',
            cell: row => <StatusPill status={row.status} data-id="element-301" />
          }, {
            header: 'Actions',
            cell: () => <Button variant="ghost" size="sm" data-id="element-302">
                        Edit
                      </Button>
          }]} data-id="element-299" />
            </div>}
          {activeTab === 'integrations' && <div className="space-y-4" data-id="element-303">
              <h3 className="text-lg font-semibold text-text-primary" data-id="element-304">
                System Integrations
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-305">
                <div className="p-4 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-306">
                  <div className="flex justify-between items-center mb-2" data-id="element-307">
                    <h4 className="font-bold text-text-primary" data-id="element-308">SAP S/4HANA</h4>
                    <StatusPill status="Active" data-id="element-309" />
                  </div>
                  <p className="text-sm text-text-secondary mb-4" data-id="element-310">
                    Master data, POs, Invoices sync
                  </p>
                  <Button variant="secondary" size="sm" className="w-full" data-id="element-311">
                    Configure
                  </Button>
                </div>
                <div className="p-4 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-312">
                  <div className="flex justify-between items-center mb-2" data-id="element-313">
                    <h4 className="font-bold text-text-primary" data-id="element-314">SAP Ariba</h4>
                    <StatusPill status="Active" data-id="element-315" />
                  </div>
                  <p className="text-sm text-text-secondary mb-4" data-id="element-316">
                    Sourcing events integration
                  </p>
                  <Button variant="secondary" size="sm" className="w-full" data-id="element-317">
                    Configure
                  </Button>
                </div>
                <div className="p-4 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-318">
                  <div className="flex justify-between items-center mb-2" data-id="element-319">
                    <h4 className="font-bold text-text-primary" data-id="element-320">DocuSign</h4>
                    <StatusPill status="Pending" data-id="element-321" />
                  </div>
                  <p className="text-sm text-text-secondary mb-4" data-id="element-322">
                    eSignature for contracts
                  </p>
                  <Button variant="primary" size="sm" className="w-full" data-id="element-323">
                    Connect
                  </Button>
                </div>
              </div>
            </div>}
          {activeTab !== 'workflows' && activeTab !== 'integrations' && <div className="py-8 text-center text-text-secondary" data-id="element-324">
              <SettingsIcon className="w-12 h-12 mx-auto mb-4 text-border-strong" data-id="element-325" />
              <p data-id="element-326">
                Configuration options for {activeTab} are available in the full
                system.
              </p>
            </div>}
        </div>
      </Card>
    </div>;
};